<template>
  <layout-default class="page-index">
    <layout-introduction
      title="Jerome Dupuis"
      subtitle="ジェローム・ドゥプイ"
      lead="Full Stack Engineer, specialized for Front End and SPA development."
    />
    <index-about :readmore="true" />
    <index-skills />
    <index-clients />
    <index-works />
    <index-contact />

  </layout-default>
</template>

<script>
import LayoutDefault from '@/components/layouts/default/Layout';
import LayoutIntroduction from '@/components/layouts/common/Introduction';
import IndexAbout from '../common/About';
import IndexSkills from '../common/Skills';
import IndexClients from '../common/Clients';
import IndexWorks from './Works';
import IndexContact from '../common/Contact';

export default {
  metaInfo: {
    title: 'Jerome Dupuis Portfolio'
  },
  components: {
    LayoutDefault,
    LayoutIntroduction,
    IndexAbout,
    IndexSkills,
    IndexWorks,
    IndexClients,
    IndexContact
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/index/Index.vue